module.exports = __webpack_public_path__ + "static/media/eye_close.19256f20.png";